import EmptyRowBody from './EmptyRowBody'
export default EmptyRowBody
